<template>
  <div class="pt-6 pb-10 text-center border-2 border-black rounded-lg bg-opacity-default">
    <h1 class="mb-0">Créer son compte</h1>
    <form @submit.prevent="register()" class="justify-center p-grid">
      <div class="p-col-10">
        <div class="my-8">
          <div class="text-left p-field">
            <label for="register_username">Identifiant</label>
            <div class="p-inputgroup">
              <InputText
                id="register_username"
                v-model="form.username"
                type="text"
                placeholder="Cho7du67"
                class="w-full"
                required
              />
            </div>

            <div class="errors" v-if="errors.username">
              <Message severity="error">
                <p v-for="(error, key) in errors.username" :key="key">
                  {{ error }}
                </p>
              </Message>
            </div>
          </div>
          <div class="text-left p-field">
            <label for="register_email">Adresse mail</label>
            <div class="p-inputgroup">
              <InputText
                id="register_email"
                v-model="form.email"
                type="email"
                placeholder="tom@farcie.com"
                class="w-full"
                required
              />
            </div>

            <div class="errors" v-if="errors.email">
              <Message severity="error">
                <p v-for="(error, key) in errors.email" :key="key">
                  {{ error }}
                </p>
              </Message>
            </div>
          </div>
          <div class="text-left p-field">
            <label for="register_password">Mot de passe</label>
            <div class="flex">
              <div class="p-inputgroup">
                <InputText
                  id="register_password"
                  v-model="form.password"
                  :type="visible_password ? 'text' : 'password'"
                  placeholder="Doit contenir au moins 5 caractères"
                  class="w-full"
                  minlength="5"
                  required
                />
              </div>

              <Button
                class="ml-2"
                @click="togglePasswordVisibility()"
                :icon="visible_password ? 'mdi-eye' : 'mdi-eye-off'"
              />
            </div>

            <div class="errors" v-if="errors.password">
              <Message severity="error">
                <p v-for="(error, key) in errors.password" :key="key">
                  {{ error }}
                </p>
              </Message>
            </div>
          </div>
          <div class="text-left p-field">
            <label for="register_c_password"
            >Confirmation du mot de passe</label
            >
            <div class="flex">
              <div class="p-inputgroup">
                <InputText
                  id="register_c_password"
                  v-model="form.c_password"
                  :type="visible_password ? 'text' : 'password'"
                  placeholder="La même chose qu’au dessus"
                  class="w-full"
                  minlength="5"
                  required
                />
              </div>

              <Button
                class="ml-2"
                @click="togglePasswordVisibility()"
                :icon="visible_password ? 'mdi-eye' : 'mdi-eye-off'"
              />
            </div>

            <div class="errors" v-if="errors.c_password">
              <Message severity="error">
                <p v-for="(error, key) in errors.c_password" :key="key">
                  {{ error }}
                </p>
              </Message>
            </div>
          </div>
          <div class="my-4">
            <Checkbox
              id="conditions"
              name="conditions"
              class="mr-2"
              v-model="form.conditions"
              :binary="true"
              required
            />
            <label for="conditions">
              J'accepte les
              <router-link class="link" :to="{ name: 'CGU' }">
                <span>conditions d'utilisation</span>
              </router-link>
              de CodeSnippet
            </label>
          </div>
        </div>

        <div class="flex justify-end">
          <Button
            type="submit"
            class="btn-green"
            label="S'inscrire"
            :is-loading="isRegistering"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapActions } from "vuex"

export default {
  data: () => ({
    form: {
      username: "",
      email: "",
      password: "",
      c_password: "",
      conditions: false,
    },
    visible_password: false,
    errors: [],
    isRegistering: false,
  }),
  methods: {
    ...mapActions({
      registerStore: "auth/register",
    }),
    async register() {
      try {
        this.isRegistering = true
        await this.registerStore(this.form)
        await this.$router.push({ name: "Dashboard" })
      }
      catch (e) {
        const { error, errors, firebase } = e
        this.errors = errors ?? []
        this.isRegistering = false
        let details = "Une erreur est survenue lors de la création du compte."
        if (firebase) details += " (Firebase)"
        this.$toast.add({
          severity: "error",
          summary: "Impossible de créer le compte",
          detail: details,
          life: 3000,
        });
      }
      finally {
        this.isRegistering = false
      }
    },
    togglePasswordVisibility() {
      this.visible_password = !this.visible_password
    },
  },
}
</script>
